"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require("babel-polyfill");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _editor = require("./editor");

var _editor2 = _interopRequireDefault(_editor);

var _preview = require("./preview");

var _preview2 = _interopRequireDefault(_preview);

var _es6Preview = require("./es6-preview");

var _es6Preview2 = _interopRequireDefault(_es6Preview);

var _doc = require("./doc");

var _doc2 = _interopRequireDefault(_doc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-unused-vars:0 */


var ReactPlayground = function (_Component) {
  _inherits(ReactPlayground, _Component);

  function ReactPlayground() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ReactPlayground);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReactPlayground.__proto__ || Object.getPrototypeOf(ReactPlayground)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      code: _this.props.codeText,
      expandedCode: _this.props.initiallyExpanded,
      external: true
    }, _this.componentWillReceiveProps = function (nextProps) {
      _this.setState({
        code: nextProps.codeText,
        external: true
      });
    }, _this._handleCodeChange = function (code) {
      _this.setState({
        code: code,
        external: false
      });
    }, _this._toggleCode = function () {
      _this.setState({
        expandedCode: !_this.state.expandedCode
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ReactPlayground, [{
    key: "render",
    value: function render() {
      var _state = this.state,
          code = _state.code,
          external = _state.external,
          expandedCode = _state.expandedCode;
      var _props = this.props,
          collapsableCode = _props.collapsableCode,
          context = _props.context,
          docClass = _props.docClass,
          es6Console = _props.es6Console,
          noRender = _props.noRender,
          previewComponent = _props.previewComponent,
          propDescriptionMap = _props.propDescriptionMap,
          scope = _props.scope,
          selectedLines = _props.selectedLines,
          theme = _props.theme;


      return _react2.default.createElement(
        "div",
        { className: "playground" + (collapsableCode ? " collapsableCode" : "") },
        docClass ? _react2.default.createElement(_doc2.default, {
          componentClass: docClass,
          propDescriptionMap: propDescriptionMap }) : null,
        _react2.default.createElement(
          "div",
          { className: "playgroundCode" + (expandedCode ? " expandedCode" : "") },
          _react2.default.createElement(_editor2.default, {
            className: "playgroundStage",
            codeText: code,
            external: external,
            onChange: this._handleCodeChange,
            selectedLines: selectedLines,
            theme: theme })
        ),
        collapsableCode ? _react2.default.createElement(
          "div",
          { className: "playgroundToggleCodeBar" },
          _react2.default.createElement(
            "span",
            { className: "playgroundToggleCodeLink", onClick: this._toggleCode },
            expandedCode ? "collapse" : "expand"
          )
        ) : null,
        _react2.default.createElement(
          "div",
          { className: "playgroundPreview" },
          es6Console ? _react2.default.createElement(_es6Preview2.default, {
            code: code,
            scope: scope }) : _react2.default.createElement(_preview2.default, {
            context: context,
            code: code,
            scope: scope,
            noRender: noRender,
            previewComponent: previewComponent })
        )
      );
    }
  }]);

  return ReactPlayground;
}(_react.Component);

ReactPlayground.defaultProps = {
  theme: "monokai",
  noRender: true,
  context: {},
  initiallyExpanded: false
};
ReactPlayground.propTypes = {
  codeText: _propTypes2.default.string.isRequired,
  scope: _propTypes2.default.object.isRequired,
  collapsableCode: _propTypes2.default.bool,
  docClass: _propTypes2.default.func,
  propDescriptionMap: _propTypes2.default.object,
  theme: _propTypes2.default.string,
  selectedLines: _propTypes2.default.array,
  noRender: _propTypes2.default.bool,
  es6Console: _propTypes2.default.bool,
  context: _propTypes2.default.object,
  initiallyExpanded: _propTypes2.default.bool,
  previewComponent: _propTypes2.default.node
};
exports.default = ReactPlayground;


//////////////////
// WEBPACK FOOTER
// ./node_modules/component-playground/lib/components/playground.js
// module id = 1062
// module chunks = 0